export enum TrackingCode {
    FreeAccessSubscribe = "W671", // https://link.nfpa.org/sign-up/register/trial?icid=W671&callback_url=%2Fsign-up%2Fregister%2Ftrial
}
